import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../Layout/PageHeader';
import PersonAvatar from '../Layout/PersonAvatar';
import team from '../../assets/images/team2.jpg';
import founder1 from '../../assets/images/Milos Vulic - selfie.png';
import founder2 from '../../assets/images/Nikola.png';

const About = () => {
  const founders = [
    {
      name: 'Miloš Vulić',
      position: 'CEO | Android & Backend Developer',
      image: founder1,
      scalerClass: 'person-card__avatar-scaler--milos-founder',
    },
    {
      name: 'Nikola Marković',
      position: 'QA / Project Manager',
      image: founder2,
      scalerClass: 'person-card__avatar-scaler--nikola-founder',
    },
  ];

  const facts = [
    { title: 'Satisfied Clients', info: 'Proven track record across industries' },
    { title: 'Projects Delivered', info: 'Mobile apps, websites, and platforms' },
    { title: 'Global Partners', info: 'Collaborations across Europe' },
  ];

  return (
    <main className="page">
      <div className="page__inner">
        <div className="hero-banner">
          <img src={team} alt="NeoApps team" className="hero-banner__image" />
          <div className="hero-banner__overlay">
            <h2 className="hero-banner__title">Building digital products that matter</h2>
            <p className="hero-banner__text">
              NeoApps combines design, engineering, and product thinking to deliver modern websites
              and mobile applications for businesses worldwide.
            </p>
            <Link to="/contact" className="btn-white">Get in touch</Link>
          </div>
        </div>

        <PageHeader
          label="About"
          title="Who we are"
          description="We are an independent team passionate about technology, focused on building reliable software with clean design and long-term value."
        />

        <section className="section-block">
          <h2 className="section-block__title">Founders</h2>
          <div className="grid-2">
            {founders.map((founder) => (
              <article key={founder.name} className="surface-card person-card">
                <PersonAvatar src={founder.image} alt={founder.name} scalerClass={founder.scalerClass} />
                <h3 className="person-card__name">{founder.name}</h3>
                <p className="person-card__role">{founder.position}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section-block">
          <h2 className="section-block__title">Fast facts</h2>
          <div className="grid-3">
            {facts.map((fact) => (
              <article key={fact.title} className="surface-card stat-card">
                <h3 className="stat-card__value">{fact.title}</h3>
                <p className="stat-card__label">{fact.info}</p>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
};

export default About;
